const PRO_PLAN_INTERVAL = 'year';
export const buildUpgradeUrl = (opts) => {
    const url = opts.upgradePlanId
        ? `/app/planbuilder/checkout?planId=${opts.upgradePlanId}`
        : '/app/planbuilder/plans';
    return encodeURI(url);
};
export const getProfessionalPlanData = (possiblePlans) => {
    var _a, _b, _c;
    const professionalPlans = (_c = (_b = (_a = possiblePlans.filter((plan) => plan.planType === 'Professional')) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.plans) !== null && _c !== void 0 ? _c : [];
    const professionalPlansSortedByIncludedTasks = [...professionalPlans].sort(({ includedTasksPerMonth: a }, { includedTasksPerMonth: b }) => a - b);
    const professionalPlan = professionalPlansSortedByIncludedTasks === null || professionalPlansSortedByIncludedTasks === void 0 ? void 0 : professionalPlansSortedByIncludedTasks.find((plan) => plan.interval === PRO_PLAN_INTERVAL);
    const professionalUpgradeUrl = buildUpgradeUrl({
        upgradePlanId: professionalPlan === null || professionalPlan === void 0 ? void 0 : professionalPlan.id,
    });
    const professionalPlanAmount = ((professionalPlan === null || professionalPlan === void 0 ? void 0 : professionalPlan.amount) || 0) / 12;
    return { professionalUpgradeUrl, professionalPlanAmount };
};
//# sourceMappingURL=getProfessionalPlanData.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
